module.exports = __webpack_public_path__ + "img/join1.03376a7c.png";